import { FC } from "react";
import { useTranslation } from "react-i18next";
import { track } from "@amplitude/analytics-browser";

const RateConditionsTrigger: FC<{ onOpen: () => void }> = ({ onOpen }) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={() => {
        track("Rate Conditions Viewed");
        onOpen();
      }}
      className="text-font-active border-border-default hover:bg-background-minimal flex shrink-0 cursor-pointer items-center gap-2 self-end rounded-full border px-4 py-1.5 text-sm font-semibold transition-colors md:self-auto"
    >
      {t("Hotels.guests.readInfo")}
    </button>
  );
};

export default RateConditionsTrigger;
